import { ACTION } from "@common/constants/redux";

export const setInventoryFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: ACTION.SET_INVENTORY_FILTER,
      payload: filter,
    });
  };
};
